import {
  GSTDETAIL_REPORT_REQUEST,
  GSTDETAIL_REPORT_SUCCESS,
  GSTDETAIL_REPORT_FAILURE,
} from "../types/gst-detail-report-types";

const initialState = {
  gstDetailReport: {},
  loading: false,
  error: null,
};

const gstDetailReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GSTDETAIL_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GSTDETAIL_REPORT_SUCCESS: {
      return {
        ...state,
        gstr2Report: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GSTDETAIL_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default gstDetailReportReducer;
